import React from 'react'
import { InputBase, FormControl } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'

export const StyledInputBase = withStyles(theme => ({
  input: {
    position: 'relative',
    border: `2px solid ${theme.palette.textfield.border}`,
    borderRadius: '5px',
    width: '100%',
    padding: '8px 12px',
    fontFamily: 'Lato',
    backgroundColor: ({ value }) =>
      value?.length === 0 || !value ? theme.palette.textfield.empty : 'inherit',
    fontSize: theme.size.sm,

    '&:focus': {
      borderColor: theme.palette.textfield.focused,
      boxShadow: `0 0 0 0.2rem ${theme.palette.textfield.focusGlow}`
    }
  }
}))(InputBase)

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%'
  },

  label: {
    opacity: '1',
    margin: '0 0 0.5rem 0.5rem',
    fontSize: theme.size.base
  }
}))

const TextField = ({ label, className, ...props }, ref) => {
  const classes = useStyles()

  return (
    <FormControl className={clsx(classes.form, className)}>
      {label && <div className={classes.label}>{label}</div>}

      <StyledInputBase ref={ref} {...props} />
    </FormControl>
  )
}

export default React.forwardRef(TextField)
